import {
  Anchor,
  Button,
  Card,
  Center,
  Divider,
  Stack,
  ThemeIcon,
  Title,
  Image,
  TypographyStylesProvider,
} from "@mantine/core";
import React from "react";
import DocsHighlightCard from "../articlesHelpers/DocsHighlightCard";
import DocsButton from "../articlesHelpers/DocsButton"; // Import the new component
import {
  IconArrowBigDownFilled,
  IconArrowBigUpFilled,
  IconCircleMinus,
  IconExchange,
} from "@tabler/icons-react";
import SimpleImage from "../articlesHelpers/SimpleImage";

export const CLOSING_CHANNELS_CONTENT = (
  <TypographyStylesProvider>
    <p>
      To close a channel, use the button on the upper-right of the channel
      display.
    </p>

    <SimpleImage src="docs_images/close-channel-button.png" h={250} />

    <p>
      There is a detail about channel closures which is important to understand.
      Closing a channel requires an on-chain transaction, and therefore, a fee
      must be paid.
    </p>

    <p>But critically, the fee is paid BY THE NODE THAT OPENED THE CHANNEL.</p>

    <p>
      So, for our purposes, if your channel was opened after using the "Get
      Inbound" button, that means that Rizful Node LSP opened the channel to
      you, and Rizful Node LSP will pay the closure fees,{" "}
      <em>even if you initiate the channel closure</em>.
    </p>

    <p>
      If, on the other hand, <em>you</em> opened the channel, then you will pay
      the channel closure fee.{" "}
    </p>

    <p>
      Once you click the Close Channel button, you'll then be asked to confirm
      the closure.
    </p>

    <SimpleImage src="docs_images/confirm-close-channel.png" h={250} />
    <p> You'll need to type in the word "close" to confirm the closure.</p>

    <p>
      {" "}
      You should then see that the channel goes into a CLOSING state, like this:
    </p>

    <SimpleImage h={150} src="docs_images/closing-channel-state2.png" />
  </TypographyStylesProvider>
);
